
export class IndicadorAnaliseColeta {
    idColeta: number | null;
    analise: string | null;

    constructor(
        idColeta = 0,
        analise = ""
    ) {
        this.idColeta = idColeta;
        this.analise = analise;
    }
}